import { render, staticRenderFns } from "./GGroupDraggable.vue?vue&type=template&id=28875840&scoped=true&"
import script from "./GGroupDraggable.vue?vue&type=script&lang=ts&"
export * from "./GGroupDraggable.vue?vue&type=script&lang=ts&"
import style0 from "./GGroupDraggable.vue?vue&type=style&index=0&id=28875840&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28875840",
  null
  
)

export default component.exports